<template>
  <div class="cardDetail">
    <div class="cardDetailWrapper">
      <div class="header">
        <van-icon name="arrow-left" @click="$router.back()" />
        <div class="title">{{ $route.query.name }}详情</div>
        <div></div>
      </div>
      <div class="cardDetailContent">
        <van-list
          v-model="loadingTwo"
          :finished="finishedTwo"
          finished-text="没有更多了"
          @load="onLoadTwo"
          :immediate-check="false"
        >
          <div
            class="detail_item"
            v-for="(item, index) in listTwo1"
            :key="index"
          >
            <van-cell-group>
              <van-field
                v-model="item.createDateFormat"
                label="发卡时间"
                input-align="right"
                readonly
              />
            </van-cell-group>
            <van-cell-group>
              <van-field
                v-model="item.sendername"
                label="发卡人"
                input-align="right"
                readonly
              />
            </van-cell-group>
            <van-cell-group>
              <van-field
                v-model="item.medalName"
                label="价值观关键词"
                input-align="right"
                readonly
              />
            </van-cell-group>
            <van-cell-group>
              <van-field
                v-model="item.point"
                label="分值"
                input-align="right"
                readonly
              />
            </van-cell-group>
            <div class="textArea">
              <van-cell-group>
                <van-field
                  v-model="item.reason"
                  rows="2"
                  autosize
                  label="获卡原因"
                  type="textarea"
                  readonly
                />
              </van-cell-group>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/apis/medal";
import apiLogin from "@/apis";
import { getToken } from "@/utils/cookie";

export default {
  name: "cardDetail",
  data() {
    return {
      card: {
        card: "2024-06-11"
      },
      empno: "",
      badgeInfoList: [],
      listTwo1: [],
      loadingTwo: false,
      finishedTwo: false,
      totalAllTwo1: 0,
      pageTwo: 1,
      pageSize: 20
    };
  },
  mounted() {
    this.listTwo1 = [];
    let hrToken = getToken();
    //获取token
    if (hrToken) {
      this.empno = hrToken;
      this.getBadgeListTwo();
    } else {
      this.$bus.$on("processToken", res => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.empno = res;
          this.getBadgeListTwo();
        });
      });
    }
  },
  methods: {
    //获取hrToken&用户信息
    getHrToken(username) {
      return new Promise(resolve => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;

          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then(data => {
            const info = data.data;
            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          resolve();
        }
      });
    },
    onLoadTwo() {
      this.getBadgeListTwo()
    },
    //获取徽章列表
    getBadgeListTwo() {
      api
        .medalCardRevApi({
          page: this.pageTwo,
          pageSize: this.pageSize,
          empno: this.empno,
          hrAuthToken: window.sessionStorage.hrToken,
          medalId: this.$route.query.id
        })
        .then(res => {
          if (res.code == 200) {
            this.totalAllTwo1 = res.total;
            this.finishedTwo = false;
            if (this.pageTwo === 1) {
              this.listTwo1 = res.data;
            } else {
              this.listTwo1 = this.listTwo1.concat(res.data);
            }
            if (this.listTwo1.length < this.totalAllTwo1) {
              this.pageTwo = this.pageTwo + 1;
            } else {
              this.finishedTwo = true;
            }
            this.loadingTwo = false;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .cardDetail {
    width: 100%;
  }

  .footerBtn {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .cardDetail {
    width: 276px * $zoom;
  }

  .footerBtn {
    width: 276px * $zoom;
  }
}

.cardDetail {
  margin: auto;
  background-color: #f3f3f5;
  .cardDetailWrapper {
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 80px;
      background-color: #fff;
      .title {
        font-weight: 800;
        font-size: 36px;
        color: #282b32;
      }
      ::v-deep {
        .van-icon {
          margin-left: 24px;
        }
      }
    }
  }
  .cardDetailContent {
    height: calc(100vh - 80px);
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    .detail_item {
      margin-bottom: 22px;
      .textArea {
        ::v-deep {
          .van-cell {
            display: flex;
            flex-direction: column;
            padding-bottom: 40px;
          }
          .van-field__value {
            background: rgba(244, 244, 244, 1);
            padding: 20px 20px;
            border-radius: 10px;
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
